export const STORAGE_KEYS = {
    TOKEN: 'token_key',
    REFRESH_TOKEN: 'refresh_token_key',
    USER: 'user_storage_key',
    MENU_ITEM: 'menuitem_key',
    SESSION_MONITOR: 'session_monitoring_key',
    DARK_THEME: 'dark_layout_config'
} as const;
